import { FormProvider } from 'react-hook-form';
import { FontWeight, Heading, LiliButton, LiliButtonType, LiliPasswordInput } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ControllerWrapper } from '../../../hooks/providers/ControllerWrapper';
import { useTempPasswordLogic } from '../hooks/useTempPasswordLogic';

export const TempPassword = () => {
  const { t } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useTempPasswordLogic();

  return (
    <div className='w-full h-full flex flex-col grow bg bg-surface-primary-bw-01'>
      <div className='w-full h-[56px] shadow-bottomShadow border-b border-outline-primary-bw-03 bg-surface-primary-bw-00 flex items-center justify-center'>Change Password</div>
      <div className='w-[504px] flex flex-col gap-[28px] mx-auto my-auto shadow-light border border-outline-primary-bw-03 rounded-[12px] bg-surface-primary-bw-00 pt-[40px] px-[32px] pb-[32px]'>
        <Heading.H5 fontWeight={FontWeight.MEDIUM}>{t('temp_password.mainTitle')}</Heading.H5>
        <Heading.H9 fontWeight={FontWeight.REGULAR}>{t('temp_password.subTitle')}</Heading.H9>
        <FormProvider {...formMethods}>
          <ControllerWrapper name='mainPassword' control={formMethods.control}>
            {({ onChange, onBlur, error }) => (
              <LiliPasswordInput
                onChange={onChange}
                id='mainPassword'
                title={t('temp_password.mainPassword')}
                errorMessage={error?.message}
                onBlur={onBlur}
                passwordStrengthHints={[
                  t('temp_password.passwordHints.minimumChars'),
                  t('temp_password.passwordHints.uppercaseLetter'),
                  t('temp_password.passwordHints.number'),
                ]}
                passwordStrengthTexts={{
                  tooWeak: t('temp_password.passwordStrength.tooWeak'),
                  weak: t('temp_password.passwordStrength.weak'),
                  medium: t('temp_password.passwordStrength.medium'),
                  strong: t('temp_password.passwordStrength.strong'),
                }}
                tabIndex={0}
              />
            )}
          </ControllerWrapper>
          <ControllerWrapper name='secondaryPassword' control={formMethods.control}>
            {({ onChange, onBlur, error }) => (
              <LiliPasswordInput
                onChange={onChange}
                id='secondaryPassword'
                title={t('temp_password.secondaryPassword')}
                errorMessage={error?.message}
                onBlur={onBlur}
                tabIndex={0}
              />
            )}
          </ControllerWrapper>
          <LiliButton isLoading={isLoading} onClick={handleSubmit} id='submit' disabled={!formMethods.formState.isValid || isLoading} type={LiliButtonType.PRIMARY} title={t('temp_password.CTA')} />
        </FormProvider>
      </div>
    </div>
  );
};
